var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-layout"},[_vm._t("default"),_vm._t("modals")],2)}
var staticRenderFns = []

export { render, staticRenderFns }